// Operations routes: projects, PECE, contracts execution, subcontracts, employees, fleet, equipment, claims, visits
import Projects from '../pages/Projects';
import ProjectControlHub from '../pages/ProjectControlHub';
import ProjectExecutionCenter from '../pages/ProjectExecutionCenter';
import ProjectEvidenceTimeline from '../pages/ProjectEvidenceTimeline';
import ContractExecutionCenter from '../pages/ContractExecutionCenter';
import ComplianceCenter from '../pages/ComplianceCenter';
import PECEWorkspace from '../pages/PECEWorkspace';
import ECPInspector from '../pages/ECPInspector';
import S2PReviewQueue from '../pages/S2PReviewQueue';
import S2PEffectivenessDashboard from '../pages/S2PEffectivenessDashboard';
import MARReviewQueue from '../pages/MARReviewQueue';
import MIRReviewQueue from '../pages/MIRReviewQueue';
import DeliveryDashboard from '../pages/DeliveryDashboard';
import ConsumptionReality from '../pages/ConsumptionReality';
import PECEClaimsQueue from '../pages/PECEClaimsQueue';
import Employees from '../pages/Employees';
import Payroll from '../pages/Payroll';
import EmployeeAccounts from '../pages/EmployeeAccounts';
import VariationOrders from '../pages/VariationOrders';
import VOQueue from '../pages/VOQueue';
import ProgressClaims from '../pages/ProgressClaims';
import Equipment from '../pages/Equipment';
import Fleet from '../pages/Fleet';
import Subcontractors from '../pages/Subcontractors';
import Subcontracts from '../pages/Subcontracts';
import SubcontractClaims from '../pages/SubcontractClaims';
import VisitForm from '../pages/VisitForm';
import VisitReportsSystem from '../pages/VisitReportsSystem';
import FieldVisits from '../pages/FieldVisits';
import CostAllocationRules from '../pages/CostAllocationRules';

const operationsRoutes = [
  { path: '/projects', Component: Projects },
  { path: '/projects/:projectId/pece', Component: PECEWorkspace },
  { path: '/projects/:projectId/control-hub', Component: ProjectControlHub },
  { path: '/project-execution', Component: ProjectExecutionCenter },
  { path: '/project-execution/:projectId', Component: ProjectExecutionCenter },
  { path: '/project-execution/:projectId/evidence', Component: ProjectEvidenceTimeline },
  { path: '/contract-execution', Component: ContractExecutionCenter },
  { path: '/compliance-center', Component: ComplianceCenter },
  { path: '/ecp', Component: ECPInspector },
  { path: '/pece/s2p', Component: S2PReviewQueue },
  { path: '/pece/s2p/dashboard', Component: S2PEffectivenessDashboard },
  { path: '/pece/mar', Component: MARReviewQueue },
  { path: '/pece/mir', Component: MIRReviewQueue },
  { path: '/pece/deliveries', Component: DeliveryDashboard },
  { path: '/pece/consumption', Component: ConsumptionReality },
  { path: '/pece/claims', Component: PECEClaimsQueue },
  { path: '/employees', Component: Employees },
  { path: '/payroll', Component: Payroll },
  { path: '/employee-accounts', Component: EmployeeAccounts },
  { path: '/variation-orders', Component: VariationOrders, withUser: true },
  { path: '/vo-queue', Component: VOQueue },
  { path: '/progress-claims', Component: ProgressClaims, withUser: true },
  { path: '/equipment', Component: Equipment, withUser: true },
  { path: '/fleet', Component: Fleet, withUser: true },
  { path: '/subcontractors', Component: Subcontractors, withUser: true },
  { path: '/subcontracts', Component: Subcontracts, withUser: true },
  { path: '/subcontract-claims', Component: SubcontractClaims, withUser: true },
  { path: '/visit-form', Component: VisitForm, withUser: true },
  { path: '/visit-reports-system', Component: VisitReportsSystem, withUser: true },
  { path: '/field-visits', Component: FieldVisits, withUser: true },
  { path: '/cost-allocation', Component: CostAllocationRules, withUser: true },
];

export default operationsRoutes;
